var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"ui-toolbar",attrs:{"app":""}},[_c('v-spacer'),_vm._v(" "),(_vm.user)?_c('avatar-menu',{attrs:{"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }